/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterHasUserCommentKind = (typeof FilterHasUserCommentKind)[keyof typeof FilterHasUserCommentKind];

export const FilterHasUserCommentKind = {
  has_user_comment: 'has_user_comment',
} as const;
